
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSleepingSelectedIec as ObiAisTargetSleepingSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-sleeping-selected-iec.js';
 
 
 

 
 export const ObiAisTargetSleepingSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-sleeping-selected-iec',
   elementClass: ObiAisTargetSleepingSelectedIecElement,
   events: {
     
   }
  });
 
 